import { render, staticRenderFns } from "./UserCompetitionsPast.vue?vue&type=template&id=5492bd6b&scoped=true&"
import script from "./UserCompetitionsPast.vue?vue&type=script&lang=js&"
export * from "./UserCompetitionsPast.vue?vue&type=script&lang=js&"
import style0 from "./UserCompetitionsPast.vue?vue&type=style&index=0&id=5492bd6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5492bd6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5492bd6b')) {
      api.createRecord('5492bd6b', component.options)
    } else {
      api.reload('5492bd6b', component.options)
    }
    module.hot.accept("./UserCompetitionsPast.vue?vue&type=template&id=5492bd6b&scoped=true&", function () {
      api.rerender('5492bd6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserCompetitionsPast.vue"
export default component.exports